<template>
  <div class="header-top">
    <div id="app-main-header">
      <!-- Hamburger menu -->
      <div class="main-header-lhs">
        <div class v-if="showDropDown">
          <hamburger-menu-vue />
        </div>

        <!-- Logo -->
        <div class="col-6-custom username-top">
          <logo-icon-vue />
        </div>
      </div>

      <!-- Username -->
      <div class="main-header-username">
        <span> {{ selectedDetails.name }} </span>
      </div>

      <div>
      </div>

      <!-- Appuser List icon -->
      <div class="main-header-rhs">
        <a href="javascript:void(0)" v-if="appUsers.length > 0" @click="toggleShowAppUserListDropDown" class="linkto-other-members">
          <img :src="switchAppUserIcon" />
        </a>

        <a href="#" class="logout-link" @click.stop.prevent="localLogout">
          <img :src="lockIcon" />
        </a>

         <!-- App User(admin) List Drop Down menu -->
        <transition name="zoom">
          <div
            class="dropdown"
            v-if="userList.length > 1 && showAppUserListDropDown"
          >
            <div>
              <ul class="list-of-members">
                <li
                  v-for="user in filteredUserList"
                  :key="user.id"
                  :value="user.id"
                  @click="switchAppUser(user.id)"
                >
                  {{ user.name }}
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- Logout button -->
    <div class="clear"></div>
  </div>
</template>

<script>
  import HamburgerMenuVue from "../Appointment/common/HamburgerMenu";
  import LogoIconVue from "../Appointment/common/LogoIcon.vue";
  import { mapActions, mapGetters, mapMutations } from "vuex";
  import { nameMixin } from "../../mixins/nameMixin.js";
  import { permissionMixin } from "../../mixins/permissionMixin";

  export default {
    mixins: [nameMixin, permissionMixin],
    data() {
      return {
        showAppUserListDropDown: false,
        userList: [],
        selectedDetails: null
      };
    },
    computed: {
      ...mapGetters({
        userDetails: "getUserDetails" // Gets the user details
      }),
      ...mapGetters("portalemail", {
        appUsers: "getAppUsers",
        selectedUserId: "getSelectedUserId"
      }),
      switchAppUserIcon() {
        return require("../../assets/img/icon-other-members.png");
      },
      lockIcon() {
        return require("../../assets/img/lock-icon.jpg");
      },
      filteredUserList() {
        return this.userList.filter((user) => user.id !== this.selectedDetails.id);
      },
      /**
       * Username to show to the user
       */
      username() {
        const {
          firstName,
          middleName,
          lastName,
          namePrefix,
          nameSuffix,
          credentials
        } = this.userDetails;
        return this.formatName(
          firstName,
          middleName,
          lastName,
          namePrefix,
          nameSuffix,
          credentials,
          "heading"
        );
      }
    },
    components: {
      LogoIconVue,
      HamburgerMenuVue
    },
    methods: {
      ...mapMutations("portalemail", {
        setSelectedUserId: "setSelectedUserId",
        resetStateForOtherUser: "resetStateForOtherUser"
      }),
      ...mapActions({
        logout: "logout"
      }),
      localLogout() {
        this.logout(); // Sending logout request to server where the session is deleted
      },
      /**
       * Changes the currently selected app user
       */
      switchAppUser(id) {
        this.selectedDetails = this.userList.find(user => {
          return (id === user.id);
        });

        this.setSelectedUserId(this.userDetails.id === id ? 0 :this.selectedDetails.id);

        this.resetStateForOtherUser();
        if("/emails/mailboxes" !== this.$route.fullPath) {
          this.$router.push("/emails/mailboxes");
        } else {
          this.$emit('loadUserEmails')
        }
      },
      /**
       * Toggle show drop down
       */
      toggleShowAppUserListDropDown() {
        const value = this.showAppUserListDropDown;
        setTimeout(() => {
          this.showAppUserListDropDown = !value;
        });
      },
      windowClickListener() {
        this.showAppUserListDropDown = false;
      }
    },
    /**
     * Add event listeners
     */
    mounted() {
      window.addEventListener("click", this.windowClickListener);
    },
    beforeDestroy() {
      window.removeEventListener("click", this.windowClickListener);
    },
    created() {
      this.userList.push({
        id: this.userDetails.id,
        name: this.username
      });
      this.appUsers.forEach(user => {
        this.userList.push(user);
      });

      if(this.selectedUserId) {
        this.selectedDetails = this.userList.find(user => {
          return (this.selectedUserId === user.id);
        });
      } else {
        this.selectedDetails = this.userList[0];
      }
    }
  };
</script>

<style scoped>
  select {
    font-size: 16px;
    font-weight: bold;
    line-height: 31px;
    background-color: black;
    color: white;
    width: 130%;
    overflow: hidden;
    padding: 8px 5px;
    border: 2px solid white;
    outline: none;
  }

  option {
    background-color: #f7f7f7;
    color: grey;
    border-bottom: 1px solid lightgray;
  }
  .header-top-right {
    float: right;
    padding: 10px 0 0 0;
  }
  .clear {
    clear: both;
  }
  .username-text {
    display: inline-block;
    padding: 4px 10px 0 0;
    font-weight: bold;
    vertical-align: middle;
  }
  .logout-link {
    display: inline-block;
  }
  .logout-link img {
    max-width: 20px;
  }
  #app-main-header {
    width: 100%;
    margin: 0 auto;
    position: relative;
  }
  .main-header-lhs {
    position: absolute;
    left: 0;
    width: 85px;
    z-index: 999;
  }

  .main-header-username {
    user-select: none;
    cursor: pointer;
    text-align: center;
    margin: 0 auto;
    line-height: 40px;
    font-weight: 600;
  }

  .main-header-username .dropdown {
    position: absolute;
    background-color: #f8f8f8;
    color: #333;
    top: 49px;
    left: 43.5%;
    box-shadow: 1px 1px 5px lightgrey;
    border-radius: 5px;
    padding: 0.2rem 1.5rem;
    border: 1px solid #d0d0d0;
    font-size: 16px;
    color: black;
    font-weight: 540;
  }

  .main-header-username .dropdown ul li[data-v-603f0264]:not(:last-of-type) {
    border-bottom: 1px solid #d0d0d0;
  }

  .main-header-rhs {
    position: absolute;
    right: 0;
    width: 72px;
    top: 8px;
    z-index: 999;
    text-align:right;
  }
a.linkto-other-members{
  margin-right:15px;
  display: inline-block;
}
.list-of-members{
  background:#fff;
  width:140px;
  padding:10px;
  position:absolute;
  right:0;
  top:37px;
  box-shadow: -2px 3px 5px 0px rgba(0,0,0,0.2);
-webkit-box-shadow: -2px 3px 5px 0px rgba(0,0,0,0.2);
-moz-box-shadow: -2px 3px 5px 0px rgba(0,0,0,0.2);
  cursor: pointer;
}
.list-of-members li{
  margin:5px 0;
  padding:0 0 5px 0;
  border-bottom:1px solid #ccc;
    color:#000;
    font-size:14px;
    line-height: 24px;
    text-align:left;

}
.list-of-members li a{
  color:#000;
}
.list-of-members li:hover, .list-of-members li a:hover{
  color:#d26d13;
}
.list-of-members li:last-child{
  border-bottom: none;
}
  .zoom-enter-active {
    animation: zoomIn 0.5s ease-in-out;
  }

  .zoom-leave-active {
    animation: zoomOut 0.5s ease-in-out;
  }

  @keyframes zoomIn {
    from {
      opacity: 0;
    }

    50% {
      opacity: 1;
    }
  }

  @keyframes zoomOut {
    from {
      opacity: 1;
    }

    50% {
      opacity: 0;
    }

    to {
      opacity: 0;
    }
  }
@media screen and (max-width:480px){
.reply-options li a{
  font-size:12px;
}
}
</style>
